module.exports = __webpack_public_path__ + "img/footer_bg.07e631ab.jpg";